module.exports = __webpack_public_path__ + "static/wavy_music_sheet.e4a0113f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/wavy_music_sheet.png
// module id = 513
// module chunks = 35783957827783